/**
 * Product recommendations slider initialization
 * Depends on: product-slider-chevrons.js
 */
(function() {
  const SELECTORS = [
    '[data-product-recommendations-slider]',
    '[data-custom-recommendations-slider]'
  ];
  
  const initProductRecommendations = () => {
    if (!window.ProductSliderChevrons) return;
    
    SELECTORS.forEach(selector => {
      window.ProductSliderChevrons.initAll(selector, document, { initHorizontalSlider: true });
    });
  };
  
  // Initialize on load
  document.addEventListener('DOMContentLoaded', initProductRecommendations);
  
  // Listen for dynamically loaded content
  document.addEventListener('recommendations:loaded', () => {
    setTimeout(initProductRecommendations, 50);
  });
  
  // Fallback
  window.addEventListener('load', initProductRecommendations);
})();